import {SeniorityDao} from '../../dao';
import {ErrorModel} from '../../models';
import {SERVICE_CODE} from './_serviceCode';
const FUNCTION_CODE = 'DELETE_SENIORITY';

export async function deleteSeniority(
    userData: Record<string, string>,
    updateSeniorityId: number
) {
    try {
        const result = await SeniorityDao.deleteSeniority(userData.userToken, updateSeniorityId);

        return result;
    }
    catch (error: any) {
        throw ErrorModel.newError({
            code: `${SERVICE_CODE}/${FUNCTION_CODE}/ERROR`,
            message: 'Une erreur est survenue.',
            error: error
        });
    }
}

